<div class="flex flex-col h-[90dvh] max-h-full min-h-0 overflow-hidden">

  <!-- Header -->
  <div class="shrink-0 flex flex-col mb-2 pb-2 p-6 items-center gap-2">
    <h1 class="headline-small text-primary text-center">
      {{ 'Select blueprints' | translate }}
    </h1>
  </div>

  <!-- Selector: fills remaining height -->
  <div class="flex-1 min-h-0 !mb-2 px-6 flex flex-col overflow-hidden">
    <app-template-selector
      class="flex-1 min-h-0 flex flex-col"
      [loading]="isLoading"
      [templates]="templates"
      [selectedTemplates]="preSelectedTemplates"
      [disabledTemplates]="disabledTemplates"
      [singleSelection]="singleSelection"
      (selectionChange)="onSelectionChange($event)"
    >
    </app-template-selector>
  </div>

  <!-- Footer -->
  <app-dialog-footer class="shrink-0">
    <div class="flex w-full gap-4 justify-end">
      <button
        mat-stroked-button
        (click)="onCancel()">
        {{ 'Cancel' | translate }}
      </button>
      <button
        mat-flat-button
        (click)="onConfirm()"
        [disabled]="isSaving || selectedTemplates.length === 0"
      >
        <app-loading-spinner [loading]="isSaving" [diameter]="20">
          {{ 'Confirm selection' | translate }}
        </app-loading-spinner>
      </button>
    </div>
  </app-dialog-footer>

</div>